import { render } from "./MealList.vue?vue&type=template&id=33b3cff8&scoped=true"
import script from "./MealList.vue?vue&type=script&lang=js"
export * from "./MealList.vue?vue&type=script&lang=js"

import "./MealList.vue?vue&type=style&index=0&id=33b3cff8&scoped=true&lang=sass"

import exportComponent from "/Users/don/phpStorm/qr-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b3cff8"]])

export default __exports__